import {
  PURCHASE_POINTS_CONVERSIONS_PER_PAGE,
  PURCHASE_POINTS_CONVERSIONS_SCOPE,
} from "@/features/purchasePoints/config/purchasePoints.config";
import { useEmployeeScopedQuery } from "@/features/purchasePoints/hooks/useEmployeeScopedQuery";
import { purchasePointsService } from "@/features/purchasePoints/services/purchasePoints.service";
import type { PurchasePointsConversionsResponse } from "@/features/purchasePoints/types/purchasePointsConversion.type";

export const usePurchasePointsConversions = (page: number) => {
  const {
    data, isLoading, isDisabled, isFetching, error, retry,
  } = useEmployeeScopedQuery<PurchasePointsConversionsResponse>({
    scope: PURCHASE_POINTS_CONVERSIONS_SCOPE,
    key: [page],
    queryFn: () => purchasePointsService.getConversions(page, PURCHASE_POINTS_CONVERSIONS_PER_PAGE),
  });

  return {
    conversions: data?.conversions ?? [],
    metadata: data?.metadata,
    isLoading,
    isDisabled,
    isFetching,
    error,
    retry,
  };
};
